import { ref, watch, computed, onMounted } from "@vue/composition-api";
import store from "@/store";
import { title } from "@core/utils/filter";

// Notification
import { useToast } from "vue-toastification/composition";
import ToastificationContent from "@core/components/toastification/ToastificationContent.vue";
import ability from "@/libs/acl/ability";

export default function useReceiptsList() {
  // Use toast
  const toast = useToast();

  const refReceiptListTable = ref(null);

  //fileter
  const supplierFilter = ref(null);

  // Table Handlers
  const tableColumns = [
    { key: "receipt_date", label: "日期", sortable: true },
    {
      key: "receipt_number",
      label: "入倉編號",
      sortable: true,
      stickyColumn: true,
    },
    {
      key: "supplier.name",
      label: "供應商",
    },
    { key: "remark", label: "備註" },
    { key: "receipt_products", label: "產品" },
    { key: "actions", label: "操作" },
  ];

  const perPage = ref(50);
  const totalReceipts = ref(0);
  const currentPage = ref(1);
  const perPageOptions = [10, 25, 50, 100];
  const searchQuery = ref("");
  const sortBy = ref("receipt_date");
  const isSortDirDesc = ref(true);

  const dataMeta = computed(() => {
    const localItemsCount = refReceiptListTable.value
      ? refReceiptListTable.value.localItems.length
      : 0;
    return {
      from: perPage.value * (currentPage.value - 1) + (localItemsCount ? 1 : 0),
      to: perPage.value * (currentPage.value - 1) + localItemsCount,
      of: totalReceipts.value,
    };
  });

  const refetchData = () => {
    refReceiptListTable.value.refresh();
  };

  watch([currentPage, perPage, searchQuery, supplierFilter], () => {
    refetchData();
  });

  const fetchReceipts = (ctx, callback) => {
    store
      .dispatch("app-receipt/fetchReceipts", {
        q: searchQuery.value,
        perPage: perPage.value,
        page: currentPage.value,
        sortBy: sortBy.value,
        sortDesc: isSortDirDesc.value,
        supplier_id: supplierFilter.value,
      })
      .then((response) => {
        const { stock_receipts, total } = response.data;
        callback(stock_receipts);
        totalReceipts.value = total;
      })
      .catch(() => {
        toast({
          component: ToastificationContent,
          props: {
            title: "Error fetching receipts list",
            icon: "AlertTriangleIcon",
            variant: "danger",
          },
        });
      });
  };

  const supplierOptions = ref([]);

  onMounted(() => {
    store
      .dispatch("app/fetchOptionList", {
        supplier: true,
      })
      .then((response) => {
        supplierOptions.value = response.data.suppliers;
      })
      .catch((error) => {
        console.log(error);
      });
  });

  return {
    fetchReceipts,
    tableColumns,
    perPage,
    currentPage,
    totalReceipts,
    dataMeta,
    perPageOptions,
    searchQuery,
    sortBy,
    isSortDirDesc,
    refReceiptListTable,
    ability,
    refetchData,
    supplierFilter,
    supplierOptions,
    // Extra Filters
  };
}
